import { colors, font, spacing } from '@chegg-ui/theme';
import styled from 'styled-components';
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        textColor: theme.colors.border.dark900,
        verticalPadding: "".concat(6 / 16, "rem"),
        liMarginTop: '0rem',
        clMarginTop: '0rem',
        showCheckIconHorizon: true,
        iconRightMargin: "".concat(10 / 16, "rem"),
        lineHeight: theme.font.lineHeight.sm,
        letterSpacing: theme.font.letterSpacing.md,
        lg: {
          fontSize: theme.font.size.lg,
          iconSize: 'medium',
          verticalPaddingWithLine: "".concat(15 / 16, "rem")
        },
        md: {
          fontSize: theme.font.size.md,
          iconSize: 'small',
          verticalPaddingWithLine: "".concat(12 / 16, "rem")
        },
        sm: {
          fontSize: theme.font.size.sm,
          iconSize: 'xsmall',
          verticalPaddingWithLine: "".concat(12 / 16, "rem")
        }
      };
    },
    fanta: {
      textColor: colors.dark,
      verticalPadding: '0rem',
      liMarginTop: "".concat(4 / 16, "rem"),
      clMarginTop: spacing.px8,
      showCheckIconHorizon: false,
      iconRightMargin: '0rem',
      lineHeight: "".concat(19 / 16, "rem"),
      letterSpacing: '0px',
      lg: {
        fontSize: font.size.px16,
        iconSize: 'small',
        verticalPaddingWithLine: '0rem'
      },
      md: {
        fontSize: font.size.px16,
        iconSize: 'small',
        verticalPaddingWithLine: '0rem'
      },
      sm: {
        fontSize: font.size.px16,
        iconSize: 'small',
        verticalPaddingWithLine: '0rem'
      }
    },
    prop: themeProp
  };
};
export var ListUl = styled.ul.withConfig({
  componentId: "sc-1ozqylu-0"
})(["list-style-type:circle;display:inline-flex;flex-direction:column;font-family:", ";margin:0;margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;padding-inline-start:0;padding-inline-end:0;padding-left:0;", ""], font.family["default"], function (_ref) {
  var withPadding = _ref.withPadding;
  return withPadding ? 'margin-left: 1rem;' : '';
});
export var ListOl = styled.ol.withConfig({
  componentId: "sc-1ozqylu-1"
})(["display:inline-flex;flex-direction:column;font-family:", ";margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;padding-inline-start:0;padding-inline-end:0;padding-left:0;"], font.family["default"]);
export var ListLi = styled.li.withConfig({
  componentId: "sc-1ozqylu-2"
})(["display:flex;flex-direction:column;", ""], function (_ref2) {
  var numericList = _ref2.numericList;
  return numericList ? ':first-child {counter-reset: numericcounter;}' : '';
});
export var CheckListLi = styled.li.withConfig({
  componentId: "sc-1ozqylu-3"
})(["font-size:", ";display:flex;align-items:", ";color:", ";padding:", " 0;", " svg{margin-right:", ";}"], function (_ref3) {
  var customTheme = _ref3.customTheme,
      size = _ref3.size;
  return customTheme[size].fontSize;
}, function (_ref4) {
  var align = _ref4.align;
  return align === 'middle' ? 'center' : 'flex-start';
}, function (_ref5) {
  var color = _ref5.color,
      customTheme = _ref5.customTheme;
  return color === 'white' ? colors.white : customTheme.textColor;
}, function (_ref6) {
  var customTheme = _ref6.customTheme,
      showSeparatingLine = _ref6.showSeparatingLine,
      size = _ref6.size;
  return showSeparatingLine ? customTheme[size].verticalPaddingWithLine : customTheme.verticalPadding;
}, function (_ref7) {
  var showSeparatingLine = _ref7.showSeparatingLine;
  return showSeparatingLine ? 'border-top: 1px solid #e8e8ec;:last-child {border-bottom: 1px solid #e8e8ec;}' : '';
}, function (_ref8) {
  var customTheme = _ref8.customTheme;
  return customTheme.iconRightMargin;
});
export var ListItemContent = styled.div.withConfig({
  componentId: "sc-1ozqylu-4"
})(["color:", ";padding:", " 0;margin-top:", ";line-height:", ";letter-spacing:", ";display:flex;align-items:", ";&::before{content:", ";color:", ";display:inline-block;width:auto;", "  margin-right:", ";}"], function (_ref9) {
  var isSublist = _ref9.isSublist,
      color = _ref9.color,
      customTheme = _ref9.customTheme;
  return isSublist ? colors.grey700 : color === 'white' ? colors.white : customTheme.textColor;
}, function (_ref10) {
  var customTheme = _ref10.customTheme;
  return customTheme.verticalPadding;
}, function (_ref11) {
  var customTheme = _ref11.customTheme;
  return customTheme.liMarginTop;
}, function (_ref12) {
  var customTheme = _ref12.customTheme;
  return customTheme.lineHeight;
}, function (_ref13) {
  var customTheme = _ref13.customTheme;
  return customTheme.letterSpacing;
}, function (_ref14) {
  var align = _ref14.align;
  return align === 'middle' ? 'center' : 'flex-start';
}, function (_ref15) {
  var type = _ref15.type;
  return type === 'circle' ? "'\\025CB'" : "'\\2022'";
}, function (_ref16) {
  var color = _ref16.color;
  return color ? colors[color] : colors.grey700;
}, function (_ref17) {
  var type = _ref17.type;
  return type === 'circle' ? 'font-size: 13px; ' : '';
}, spacing.px12);
export var CheckListItemContent = styled.div.withConfig({
  componentId: "sc-1ozqylu-5"
})(["", " line-height:", ";letter-spacing:", ";"], function (_ref18) {
  var align = _ref18.align,
      customTheme = _ref18.customTheme;
  return align === 'top' ? "margin-top: ".concat(customTheme.clMarginTop, ";") : '';
}, function (_ref19) {
  var customTheme = _ref19.customTheme;
  return customTheme.lineHeight;
}, function (_ref20) {
  var customTheme = _ref20.customTheme;
  return customTheme.letterSpacing;
});
export var NumericListItemContent = styled.div.withConfig({
  componentId: "sc-1ozqylu-6"
})(["color:", ";padding:", " 0;margin-top:", ";line-height:", ";letter-spacing:", ";display:flex;align-items:", ";&::before{counter-increment:numericcounter;content:counter(numericcounter) '.';color:", ";display:inline-block;width:auto;margin-right:", ";}"], function (_ref21) {
  var color = _ref21.color,
      customTheme = _ref21.customTheme;
  return color === 'white' ? colors.white : customTheme.textColor;
}, function (_ref22) {
  var customTheme = _ref22.customTheme;
  return customTheme.verticalPadding;
}, function (_ref23) {
  var customTheme = _ref23.customTheme;
  return customTheme.liMarginTop;
}, function (_ref24) {
  var customTheme = _ref24.customTheme;
  return customTheme.lineHeight;
}, function (_ref25) {
  var customTheme = _ref25.customTheme;
  return customTheme.letterSpacing;
}, function (_ref26) {
  var align = _ref26.align;
  return align === 'middle' ? 'center' : 'flex-start';
}, function (_ref27) {
  var color = _ref27.color;
  return colors[color];
}, spacing.px8);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/list/dist/esm/styles.js
// module id = 849
// module chunks = 11